<div class="limiter">
  <div class="container-login100" style="background:#f1fab7">

    <div class="wrap-login100">  
      


      <div class="container">

        <div class="row">

          <div class="col-md-7 mx-auto">

            <div class="login-box">
              <div class="col-md-12">
                <div class="row align-items-center">
                  <div class="col-md-5 p-0">
                    <div class="login-content">
                      <div class="loginlogo text-center">
                        <img src="assets/img/logo.png" alt="logo">
                      </div>
                      <div>
                        <h2>Hello Friend!</h2>
                        <span class="heading-border"></span>
                        <p class="login-welcome">Welcome back, Please login in to your account</p>
  
                      </div>
                      
                    </div>
  
                  </div>
                  <div class="col-md-7 p-0">
                    <div class="login-form">
                      
                      <form class="login100-form" #loginForm="ngForm" (ngSubmit)="ForgotForm(loginForm)" *ngIf="otpStatus.passwordshowform"> 

                        <span class="login100-form-title mb-4">
                          Forgot password
                        </span>  
                
                        <div class="wrap-input100 validate-input mb-3" data-validate = "Username is required">
                          <input class="input100" type="email" placeholder="Enter email" name="EmailID" [(ngModel)]='model.EmailID' #EmailID="ngModel" id="EmailID">
                          <span class="focus-input100"></span>
                          <span class="symbol-input100">
                            <i class="fa fa-user"></i>
                          </span>
                          <div *ngIf="rtnData && rtnData.message.EmailID" class="error">
                              {{rtnData.message.EmailID}}
                          </div>
                        </div>
                
                        <div class="wrap-input100 validate-input mb-3" data-validate = "Code is required" *ngIf="otpStatus.passwordshowSubmit">
                          <input class="input100" type="password" placeholder="Code" name="Code" id="Code" [(ngModel)]='model.Code' #Password="ngModel">
                          <span class="focus-input100"></span>
                          <span class="symbol-input100">
                            <i class="fa fa-lock"></i>
                          </span>
                          <div *ngIf="rtnData && rtnData.message.Code" class="error">
                              {{rtnData.message.Code}}
                          </div>
                        </div>
                
                        <div class="wrap-input100 validate-input mb-3" data-validate = "Password is required" *ngIf="otpStatus.passwordshowSubmit">
                          <input class="input100" type="password" name="Password" id="Password" placeholder="Password" #Password="ngModel" [(ngModel)]="model.Password">
                          <span class="focus-input100"></span>
                          <span class="symbol-input100">
                            <i class="fa fa-lock"></i>
                          </span>
                          <div *ngIf="rtnData && rtnData.message.Password" class="error">
                              {{rtnData.message.Password}}
                          </div>
                        </div>
                
                        <div class="wrap-input100 validate-input mb-3" data-validate = "Confirm Password is required" *ngIf="otpStatus.passwordshowSubmit">
                          <input class="input100" type="password" name="frmPassword2" id="frmPassword2" placeholder="Confirm Password" #frmPassword2="ngModel" [(ngModel)]="model.frmPassword2">
                          <span class="focus-input100"></span>
                          <span class="symbol-input100">
                            <i class="fa fa-lock"></i>
                          </span>
                          <div *ngIf="rtnData && rtnData.message.frmPassword2" class="error">
                              {{rtnData.message.frmPassword2}}
                          </div>
                        </div>
                
                  
                        <!-- <div class="captcha">
                          <img src="assets/img/recaptcha.jpg">
                        </div> -->
                
                        <div class="container-login100-form-btn mt-3">
                          <button class="login100-form-btn" [disabled]="!loginForm.form.valid" type="submit" *ngIf="otpStatus.passwordshowSubmit">
                            Submit
                          </button> 
                          <button type="button" class="login100-form-btn" (click)="sentOtpCode(loginForm)" *ngIf="otpStatus.passwordshowOtp">Generate Code</button>
                        </div>
                        
                        <div *ngIf="rtnData && invalidloginMsg!=''" class="alert error">
                            {{invalidloginMsg}}
                        </div>
                
                        <div *ngIf="rtnData && rtnData.success == true" class="alert alert-success">
                          {{ rtnData.message }}
                        </div>
                        <div *ngIf="rtnData && rtnData.success == false && !this.otpStatus.message" class="alert error">
                          {{ rtnData.message}}
                        </div>
                
                        <div class="text-center col mt-2">
                          <span class="forgot" style="float: none;" (click)="redirectLogin()">
                              Goto Login
                          </span>
                        </div> 
                      </form>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loginfooter">
      Copyright &copy; 2019. <a href="http://www.sifytechnologies.com/" target="_blank">Sify Technologies Limited</a>.
      All rights reserved.
    </div>
  </div>
</div>